import {
  GET_ALL_TEAMS,
  GET_FILTERED_TEAMS,
  GET_TEAM,
  LOADING_TEAM,
  ERROR_TEAM,
  ADD_TEAM,
  UPDATE_TEAM,
  DELETE_TEAM
} from "store/actions/teamAction";

export default (store = {}, action) => {
  switch (action.type) {
    case LOADING_TEAM:
      return {
        ...store,
        isLoadingTeam: action.payload
      };
    case ERROR_TEAM:
      return {
        ...store,
        errorTeam: action.payload
      };
    case GET_ALL_TEAMS:
      return {
        ...store,
        getAllTeams: action.payload
      };
    case GET_FILTERED_TEAMS:
      return {
        ...store,
        getFilteredTeams: action.payload
      };
    case GET_TEAM:
      return {
        ...store,
        getTeam: action.payload
      };
    case ADD_TEAM:
      return {
        ...store,
        addTeam: action.payload
      };
    case UPDATE_TEAM:
      return {
        ...store,
        updateTeam: action.payload
      };
    case DELETE_TEAM:
      return {
        ...store,
        deleteTeamStatus: action.payload
      };
    default:
      return store;
  }
};
